import { useUiStore } from '@/stores/ui-store';
import { useBoBrand } from '@/hooks/useBoBrand';
import { cn } from '@/lib/utils';

/**
 * Backoffice brand mark: the site's uploaded logo (dark variant in dark mode)
 * when configured, else the `b1` fallback box. Name text is rendered by the
 * caller so the two chrome slots can lay it out differently.
 */
export function BrandLogo({ className }: { className?: string }) {
  const resolvedTheme = useUiStore((s) => s.resolvedTheme);
  const { logoUrl, logoDarkUrl } = useBoBrand();
  const src = resolvedTheme === 'dark' ? logoDarkUrl ?? logoUrl : logoUrl;

  if (src) {
    return <img src={src} alt="" className={cn('h-8 w-8 shrink-0 rounded-md object-contain', className)} />;
  }
  return (
    <div
      className={cn(
        'flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-primary text-primary-foreground font-bold',
        className,
      )}
    >
      b1
    </div>
  );
}
